import Swiper from "swiper";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export default class SliderColumnAllDevices {
    constructor() {
        this.sliderInstances = new Map();
        this.sliderOptions = {
            modules: [Autoplay, Pagination, Navigation],
            slidesPerView: "auto",
            spaceBetween: 30,
            createElements: true,
            centeredSlides: true,
            autoplay: false,
            loop: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                // ✅ Ajout des boutons de navigation
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    centeredSlides: false,
                },
            },
        };
        this.mediaQuery = window.matchMedia("(max-width: 1024px)"); // Ajustez 1024px selon vos besoins
        this.handleResize(this.mediaQuery);
        this.mediaQuery.addEventListener("change", (e) => this.handleResize(e));
    }

    handleResize(e) {
        if (e.matches) {
            this.enableSliders();
        } else {
            this.disableSliders();
        }
    }

    enableSliders() {
        document
            .querySelectorAll(".is-style-slider-all-devices")
            .forEach((sliderContainer) => {
                if (!this.sliderInstances.has(sliderContainer)) {
                    this.initSlider(sliderContainer);
                    this.initObserver(sliderContainer);
                }
            });
    }

    disableSliders() {
        this.sliderInstances.forEach((swiper, sliderContainer) => {
            swiper.destroy(true, true);
            this.sliderInstances.delete(sliderContainer);

            const wrapper = sliderContainer.querySelector(".swiper-wrapper");
            if (wrapper) {
                const slides = Array.from(wrapper.children);
                slides.forEach((slide) => {
                    slide.classList.remove("swiper-slide");
                    sliderContainer.appendChild(slide);
                });
                wrapper.remove();
            }
        });
    }

    initSlider(sliderContainer) {
        console.log(
            "Total slides:",
            sliderContainer.querySelectorAll(".swiper-slide").length
        );
        console.log("Slides per view:", this.sliderOptions.slidesPerView);

        let wrapper = sliderContainer.querySelector(".swiper-wrapper");

        if (!wrapper) {
            wrapper = document.createElement("div");
            wrapper.classList.add("swiper-wrapper");
            const slides = sliderContainer.querySelectorAll(".wp-block-column");

            console.log(
                "Found slides before adding to wrapper:",
                slides.length
            ); // ✅ Vérifi

            slides.forEach((slide) => {
                slide.classList.add("swiper-slide");
                wrapper.appendChild(slide);
            });
            sliderContainer.appendChild(wrapper);
        }

        console.log("Final slides inside wrapper:", wrapper.children.length); // ✅ Vérification finale
        let nextButton = sliderContainer.querySelector(".swiper-button-next");
        if (!nextButton) {
            nextButton = document.createElement("div");
            nextButton.classList.add("swiper-button-next");
            nextButton.innerHTML =
                '<span class="dashicons dashicons-arrow-left-alt2"></span>';
            sliderContainer.appendChild(nextButton);
        }

        let prevButton = sliderContainer.querySelector(".swiper-button-prev");
        if (!prevButton) {
            prevButton = document.createElement("div");
            prevButton.classList.add("swiper-button-prev");
            prevButton.innerHTML =
                '<span class="dashicons dashicons-arrow-right-alt2"></span>';
            sliderContainer.appendChild(prevButton);
        }

        let pagination = sliderContainer.querySelector(".swiper-pagination");
        if (!pagination) {
            pagination = document.createElement("div");
            pagination.classList.add("swiper-pagination");
            sliderContainer.appendChild(pagination);
        }

        const swiperInstance = new Swiper(sliderContainer, this.sliderOptions);
        this.sliderInstances.set(sliderContainer, swiperInstance);
    }

    initObserver(sliderContainer) {
        const slides = sliderContainer.querySelectorAll(".swiper-slide");
        if (!slides.length) return;

        const firstSlide = slides[0];
        const lastSlide = slides[slides.length - 1];

        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.target === firstSlide) {
                    sliderContainer.classList.toggle(
                        "can-scroll-left",
                        !entry.isIntersecting
                    );
                }
                if (entry.target === lastSlide) {
                    sliderContainer.classList.toggle(
                        "can-scroll-right",
                        !entry.isIntersecting
                    );
                }
            });
        };

        const observerOptions = {
            root: sliderContainer,
            threshold: 1.0,
        };

        const observer = new IntersectionObserver(
            observerCallback,
            observerOptions
        );
        observer.observe(firstSlide);
        observer.observe(lastSlide);
    }
}
